import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

export interface DialogUploadInspectionData {
  name: string;
  fileType: string;
  submitDate: Date;
  uploadFileName: string;
  uploadFile: Blob;
}

@Component({
  selector: 'ebb-portal-dialog-upload-inspection-file',
  templateUrl: './dialog-upload-inspection-file.component.html'
})
export class DialogUploadInspectionFileComponent implements OnInit {
  @Input('title') title = 'Upload file';
  public submitDate = new Date().toLocaleDateString();
  public fileError = false;
  public displayFileName = 'No file selected.'
  public fileSelected: any;
  public validFileSelected = false;
  public displayFileFields = false;
  public disableFileSave = true;
  public normalDisplay = true;
  public displayFileUrl: any = null;
  public fileMaxSize = 15;
  readonly fileAcceptedTypes: string[] = [
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'image/jpeg',
    'image/png',
    'video/mpeg',
    'video/mp4'
  ];

  public formFileAttributes: FormGroup;

  public attachmentBase64 = 'data:image/png;base64,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';


  constructor(
    public readonly dialogRef: MatDialogRef<DialogUploadInspectionFileComponent>,
    private readonly fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogUploadInspectionData
  ) { }

  ngOnInit() {
    this.initializeForm();
  }

  private initializeForm(): void {
    this.formFileAttributes = this.fb.group({
      fileType: ['', Validators.required]
    });
  }

  public ebbFileInputChange(event: any) {
    this.disableFileSave = true;
    this.normalDisplay = true;

    if (event.target.files.length > 0) {
      this.fileSelected = event.target.files[0];
      if ( !this.isValidFileType(this.fileSelected) )
      {
        this.normalDisplay = false;
        this.displayFileName = `Only the following types of files can be uploaded: PDF, DOCX, JPG, PNG, and MP4.`;
        this.fileError =true;
        return;
      }
      if ( !this.checkFileSize(this.fileSelected) )
      {
        this.normalDisplay = false;
        this.displayFileName = `The file size must be less than ${this.fileMaxSize}MB`;
        this.fileError =true;
        return;
      }
      this.validFileSelected = true;
      this.data.uploadFile = this.fileSelected;
      this.data.uploadFileName = this.fileSelected.name;
      this.displayFileName = `${this.fileSelected.name}`;
    } else {
      this.normalDisplay = false;
      this.displayFileName = 'File not loaded';
      this.fileError =true;
      console.log(`File not loaded.`);
    }
  }

  public isValidFileType(file: Blob): boolean {
    let validType: boolean;
    validType = this.fileAcceptedTypes.indexOf(file.type) > -1;
    return validType;
  }

  public checkFileSize(file: Blob): boolean {
    let validSize = false;

    const fileSize: number = parseFloat((file.size / (1024 * 1024)).toFixed(3));

    ( (Math.round(fileSize*1000)) > (this.fileMaxSize*1000) ) ?
      validSize = false : validSize = true;

    return validSize;
  }

  public onCheckFileAttributesControlValidators(controlName: string): boolean {
    const retVal = (this.formFileAttributes.get(controlName).errors
                      && (this.formFileAttributes.get(controlName).dirty || this.formFileAttributes.get(controlName).touched));
    return retVal;
  }

  public onClickSave(): void {
    const currentDate: Date = new Date();
    this.data.fileType = this.formFileAttributes.get('fileType').value;
    this.data.submitDate = currentDate;
    this.dialogRef.close(this.data);
  }

  public onClickCancel(): void {
    this.dialogRef.close();
  }
}
